import { gql } from 'graphql-request';

export const CACHE_INVOICE_CHARGEBACK_QUERY = gql`
  mutation CacheInvoiceChargeback($uuid: ID!) {
    invoiceChargeback(uuid: $uuid) {
      appVersion
      errors {
        fullMessages
      }
      record {
        id
      }
      recordId
      recordNanoId
      recordUuid
      status
    }
  }
`;
